package com.upcominds.expedite.dto

import kotlinx.serialization.Serializable

@Serializable
data class MobileLogCreateRequest(
    val type: String = "ERROR",
    val platform: String? = null,
    val source: String? = null,
    val message: String,
    val stackTrace: String? = null,
    val appVersion: String? = null,
    val buildNumber: String? = null,
    val osVersion: String? = null,
    val userId: String? = null,
    val sessionId: String? = null,
    val occurredAt: String? = null
)

@Serializable
data class MobileLogResponse(
    val id: String? = null,
    val status: String = "stored"
)

@Serializable
data class MobileLogAdminDTO(
    val id: String,
    val type: String,
    val platform: String? = null,
    val source: String? = null,
    val message: String,
    val stackTrace: String? = null,
    val appVersion: String? = null,
    val buildNumber: String? = null,
    val osVersion: String? = null,
    val userId: String? = null,
    val sessionId: String? = null,
    val occurredAt: String? = null,
    val createdAt: String? = null
)

@Serializable
data class MobileLogPageDTO(
    val content: List<MobileLogAdminDTO> = emptyList(),
    val page: Int = 0,
    val size: Int = 50,
    val totalElements: Long = 0,
    val totalPages: Int = 0
)
